import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { breakpoints } from '../utilities/breakpoints'; // keep if you already have it

const crossSellCarousel = {
    state: {
        instances: []
    },

    init() {
        this.initSwipers();
        this.handleResize();
    },

    // Init every carousel on the page
    initSwipers() {
        const carousels = document.querySelectorAll('.js-cross-sell-carousel');
        carousels.forEach((el, index) => {
            // Prevent double init if this runs twice
            if (el.dataset.swiperInitialized === '1') return;
            this.initSwiper(el, index);
            el.dataset.swiperInitialized = '1';
        });
    },

    // Initialize a single Swiper instance
    initSwiper(element, index) {
        const nextBtn = element.querySelector('.swiper-button-next');
        const prevBtn = element.querySelector('.swiper-button-prev');
        const paginationEl = element.querySelector('.swiper-pagination');

        const instance = new Swiper(element, {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 8,
            navigation: {
                nextEl: nextBtn || undefined,
                prevEl: prevBtn || undefined
            },
            pagination: paginationEl
                ? { el: paginationEl, clickable: true, type: 'bullets' }
                : undefined,
            breakpoints: {
                [breakpoints.desktop]: { slidesPerView: 4 },
                [breakpoints.mobile]:  { slidesPerView: 2 }
            }
        });

        this.state.instances[index] = instance;
    },

    // Optional: keep sizes in sync on resize
    handleResize() {
        window.addEventListener('resize', () => {
            this.state.instances.forEach((inst) => inst && inst.update());
        });
    }
};

window.addEventListener('einsteinCarouselPDPLoaded', () => {
    crossSellCarousel.init();

    var LazyLoad = require('vanilla-lazyload/dist/lazyload.min.js');
    const lazyLoadInstanceEinstein = new LazyLoad({
        elements_selector: '.cross-sell-section .product-tile__img.lazy',
        threshold: 300
    });

    lazyLoadInstanceEinstein.update();
});

export default crossSellCarousel;
